import Vue from 'vue'
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    // 欢迎页面
    // 访问路由时进行懒加载
    // {
    //   path: '/',
    //   name: 'welcome',
    //   component: () => import(/* webpackChunkName: "welcome" */ './views/Welcome.vue')
    // },
    {
      path: '/rank',
      name: 'rank',
      component: () =>
        import(/* webpackChunkName: "welcome" */ './views/Rank.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () =>
        import(/* webpackChunkName: "welcome" */ './views/News.vue')
    },
    {
      path: '/newsdetail',
      name: 'newsdetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/news/NewsDetail.vue'
        )
    },
    {
      path: '/',
      name: 'market',
      component: () =>
        import(/* webpackChunkName: "welcome" */ './views/Market.vue')
    },
    {
      path: '/marketAbroad',
      name: 'marketAbroad',
      component: () =>
        import(/* webpackChunkName: "welcome" */ './views/MarketAbroad.vue')
    },
    {
      path: '/scoreList',
      name: 'scoreList',
      component: () =>
        import(/* webpackChunkName: "welcome" */ './views/ScoreList.vue')
    },
    {
      path: '/scoreDetail',
      name: 'scoreDetail',
      component: () =>
        import(/* webpackChunkName: "welcome" */ './components/page/scoreList/ScoreDetail.vue')
    },
    {
      path: '/echartsDetail',
      name: 'echartsDetail',
      component: () =>
        import(/* webpackChunkName: "welcome" */ './components/page/scoreList/EchartsDetail.vue')
    },
    {
      path: '/echartsDetailService',
      name: 'echartsDetailService',
      component: () =>
        import(/* webpackChunkName: "welcome" */ './components/page/scoreList/EchartsDetailService.vue')
    },
    {
      path: '/finance',
      name: 'finance',
      // meta: {
      //   keepAlive: true
      // },
      component: () =>
        import(/* webpackChunkName: "welcome" */ './views/Finance.vue')
    },

    {
      path: '/financeZcsrDetail',
      name: 'financeZcsrDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/finance/ZcsrDetail.vue'
        )
    },
    {
      path: '/financePplrDetail',
      name: 'financePplrDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/finance/PplrDetail.vue'
        )
    },
    {
      path: '/financeGxfDetail',
      name: 'financeGxfDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/finance/GxfDetail.vue'
        )
    },
    {
      path: '/financeZcjbDetail',
      name: 'financeZcjbDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/finance/ZcjbDetail.vue'
        )
    },
    {
      path: '/financeJlrDetail',
      name: 'financeJlrDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/finance/JlrDetail.vue'
        )
    },
    {
      path: '/financeJyhdDetail',
      name: 'financeJyhdDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/finance/JyhdDetail.vue'
        )
    },
    {
      path: '/financeYftrDetail',
      name: 'financeYftrDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/finance/YftrDetail.vue'
        )
    },
    {
      path: '/financeZjzzDetail',
      name: 'financeZjzzDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/finance/ZjzzDetail.vue'
        )
    },

    {
      path: '/production',
      name: 'production',
      component: () =>
        import(/* webpackChunkName: "welcome" */ './views/Production.vue')
    },
    {
      path: '/brandDetail',
      name: 'BrandDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/production/BrandDetail.vue'
        )
    },
    {
      path: '/baseDetail',
      name: 'BaseDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/production/BaseDetail.vue'
        )
    },
    {
      path: '/saleSecondInDetail',
      name: 'SaleSecondInDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/market/SaleSecondInDetail.vue'
        )
    },
    {
      path: '/saleSecondOutDetail',
      name: 'SaleSecondOutDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/market/SaleSecondOutDetail.vue'
        )
    },

    {
      path: '/kcSecondInDetail',
      name: 'KcSecondInDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/market/KcSecondInDetail.vue'
        )
    },
    {
      path: '/kljgThirdInDetail',
      name: 'KljgThirdInDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/market/KljgThirdInDetail.vue'
        )
    },
    {
      path: '/saleThirdOutDetail',
      name: 'saleThirdOutDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/market/SaleThirdOutDetail.vue'
        )
    },
    {
      path: '/kcThirdInDetail',
      name: 'KcThirdInDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/market/KcThirdInDetail.vue'
        )
    },
    {
      path: '/szlSecondDetail',
      name: 'SzlSecondDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/market/SzlSecondDetail.vue'
        )
    },
    {
      path: '/kcSecondOutDetail',
      name: 'KcSecondOutDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/market/KcSecondOutDetail.vue'
        )
    },
    {
      path: '/saleThirdInDetail',
      name: 'SaleThirdInDetail',
      component: () =>
        import(
          /* webpackChunkName: "welcome" */ './components/page/market/SaleThirdInDetail.vue'
        )
    },
    // 404页面，放在所有路由的后面
    // 路由级别的代码分割
    // 为路由生成独立的代码块（404.[hash].js）
    // 访问路由时进行懒加载
    {
      path: '*',
      name: 'not-found',
      component: () =>
        import(/* webpackChunkName: "404" */ './views/NotFound.vue')
    }
  ]
})
// function getAuthBeforeIn(to){
//   if(to.path==='/news'||''
//   if(sessionStorage.getItem('authNews')){

//   }
// }
// if (data.includes('GWM_DD_JYFX_YX')) { // 营销模块
//   if(to.path==='/'||to.path===)
//   sessionStorage.setItem('authMarket', true)
// }
// if (data.includes('GWM_DD_JYFX_CW')) { // 财务模块
//   sessionStorage.setItem('authFinance', true)
// }
// if (data.includes('GWM_DD_JYFX_SC')) { // 资讯模块
//   sessionStorage.setItem('authProduction', true)
// }




router.beforeEach((to, from, next) => {
  // 判断是否有权限进入
  const authNews = sessionStorage.getItem('authNews') || false // 资讯模块
  const authMarket = sessionStorage.getItem('authMarket') || false// 营销模块
  const authScoreList = sessionStorage.getItem('authScoreList') || false// 榜单
  const authMarketAbroad = sessionStorage.getItem('authMarketAbroad') || false// 营销-海外模块
  const authFinance = sessionStorage.getItem('authFinance') || false// 财务模块
  const authProduction = sessionStorage.getItem('authProduction') || false
  const authRank = sessionStorage.getItem('authRank') || false// 红黑榜模块 
  // console.log('权限', authNews, authMarket, authFinance, authProduction, authRank, authMarketAbroad) // 生产
  let isAuth = true
  if (to.path === '/' && !authMarket) { // 营销的页面
    isAuth = false
  } else if (to.path === '/MarketAbroad' && !authMarketAbroad) { // 营销-海外的页面
    isAuth = false
  }
  else if (to.path === '/scoreList' && !authScoreList) { // 榜单
    isAuth = false
  }
  else if (to.path === '/finance' && !authFinance) { // 财务的页面
    isAuth = false
  } else if (to.path === '/production' && !authProduction) { // 生产的页面
    isAuth = false
  } else if (to.path === '/news' && !authNews) { // 资讯的页面
    isAuth = false
  } else if (to.path === '/rank' && !authRank) { // 红黑榜页面
    isAuth = false
  }
  //
  if (to.path === '/' || to.path === '/finance' || to.path === '/production') {
    if (router.app.$store) {
      router.app.$store.commit('updateShowBackBtn', false)
    }
  } else {
    if (router.app.$store) {
      router.app.$store.commit('updateShowBackBtn', true)
    }
  }

  const nativeQuery = to.query
  if (!to.query.dd_full_screen) {
    if (to.query.isRouterReplace) {
      router.replace({
        path: to.path,
        query: {
          ...nativeQuery, dd_full_screen: true
        }
      })
    } else {
      router.push({
        path: to.path,
        query: {
          ...nativeQuery, dd_full_screen: true
        }
      })
    }
  }
  if (isAuth) {
    next()
  }
})
export default router
